/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_No_CreditsInputs */

const en_admin_credits_no_credits = /** @type {(inputs: Admin_Credits_No_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit records yet`)
};

const zh_admin_credits_no_credits = /** @type {(inputs: Admin_Credits_No_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无积分记录`)
};

/**
* | output |
* | --- |
* | "No credit records yet" |
*
* @param {Admin_Credits_No_CreditsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_no_credits = /** @type {((inputs?: Admin_Credits_No_CreditsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_No_CreditsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_no_credits(inputs)
	return zh_admin_credits_no_credits(inputs)
});
export { admin_credits_no_credits as "admin.credits.no_credits" }